import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { List } from 'immutable';
import { ModelData, TableRowColor } from 'yt-ng-framework';
import { ProveraPosiljaoca } from './provera-posiljaoca';

@Component({
  selector: 'app-provera-posiljaoca-component',
  templateUrl: './provera-posiljaoca-component.component.html'
})
export class ProveraPosiljaocaComponentComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
  ) { }

  Config={};
  items : List<any>;
  modelData: ModelData;
  rowColors: TableRowColor[];
  @Input() Parameters;

  ngOnInit() {
    this.items = List(this.Parameters[0].Value);
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
      // ,DefaultSortLabel: 'PROVERAPOSILJAOCA.NAZIV'
      
    }
  }

  Close(){
    this.activeModal.dismiss();
  }

}
